import React from "react";
import PropTypes from "prop-types";
import { StatusBadge } from "../../../design-system";
import { getStateMeta } from "./automationUtils";

/** Draft / Active / Paused pill with the semantic StatusBadge tone per state. */
const AutomationStateBadge = ({ state, size = "sm", className = "" }) => {
  const meta = getStateMeta(state);
  return (
    <StatusBadge variant={meta.tone} size={size} className={className} title={meta.description}>
      {meta.label}
    </StatusBadge>
  );
};

AutomationStateBadge.propTypes = {
  state: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md"]),
  className: PropTypes.string,
};

export default AutomationStateBadge;
